import type { ImageContainer } from '#server/types/image'
import { getEndpointPathBuilders } from './endpoint.ts'

const { action } = getEndpointPathBuilders('images')

export default {
  upload (container: ImageContainer) { return action('upload', { container }) },
  convertUrl: action('convert-url'),
  dataUrl (url) { return action('data-url', { url: encodeURIComponent(url) }) },
  gravatar: action('gravatar'),
}
